<script lang="ts">
  import AboutUs from '$components/blocks/homepage/AboutUs.svelte';
  import DailyWord from '$components/blocks/DailyWord.svelte';
  import HpIntro from '$components/blocks/homepage/HPIntro.svelte';
  import LearnMore from '$components/blocks/homepage/LearnMore.svelte';
  import Reviews from '$components/blocks/homepage/Reviews.svelte';
  import SupportUs from '$components/blocks/SupportUs.svelte';
  import striptags from 'striptags';
  import { _ } from 'svelte-i18n';
  import type { PageData } from './$types';
  import YoutubeWrapper from '$components/elements/YoutubeWrapper.svelte';

  export let data: PageData;
</script>

<svelte:head>
  <title>{striptags($_('page.homepage.title'))}</title>
</svelte:head>
<HpIntro />
{#if data.quote}
  <DailyWord quote={data.quote} />
{/if}
<YoutubeWrapper embedId="SVOTkYAkXPg" />
<LearnMore />
<Reviews reviews={data.reviews} />
<AboutUs />
<SupportUs />
